<template>
  <header>
    <div class="header-inner">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: ['title', 'employId'],
}
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 66px;
  background: $mainColor;
  position: fixed;
  z-index: 1;
  display: flex;

  .header-inner {
    width: var(--inner-width);
    margin: auto;

    ::v-deep.el-breadcrumb {

      // zoom: 1.5;
      font-size: 20px;

      &__inner {
        color: #fff;

        &:hover {
          color: #fff;
        }
      }
    }
  }
}
</style>